import React from 'react';
import { Button, Icon } from '@kajabi/sage-react';
import copy from 'copy-to-clipboard';

type Props = {
  value: string;
  trackClick?: () => void;
  buttonColor?: string;
  iconOnly?: boolean;
};

const CopyButton = ({
  value,
  trackClick = () => {},
  buttonColor = 'primary',
  iconOnly = false,
}: Props) => {
  const color = buttonColor === 'primary' ? Button.COLORS.PRIMARY : Button.COLORS.SECONDARY;
  const handleClick = () => {
    copy(value, { format: 'text/plain' });
    trackClick();
  };
  return (
    <Button color={color} onClick={handleClick} icon={Icon.ICONS.COPY} iconOnly={iconOnly}>
      Copy Content
    </Button>
  );
};

export default CopyButton;
